export const baseUrl= process.env.REACT_APP_BASE_URL;
export const fileUrl= process.env.REACT_APP_FILE_URL;